module.exports = __webpack_public_path__ + "media/mega-man.112e1ff7.wav";